import React, { useState, useContext } from 'react';
import { Button, Tooltip, IconButton, Menu, MenuItem } from '@material-ui/core';
import { Notifications, NotificationsOff } from '@material-ui/icons';
import usePushNotifications from '../../hooks/usePushNotifications';
import { AuthContext } from '../../context/Auth/AuthContext';
import { testNotification, testServiceWorkerNotification } from '../../utils/testNotification';
import { forceShowNotification, forceShowSWNotification } from '../../utils/forceShowNotification';

const PushNotificationButton = ({ variant = 'icon' }) => {
  const authContext = useContext(AuthContext);
  const { user } = authContext || {};
  const { isSupported, permission, isRegistered, requestPermission } = usePushNotifications();
  const [loading, setLoading] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);

  if (!isSupported) {
    return null;
  }

  const handleClick = async (event) => {
    if (permission === 'granted' && isRegistered) {
      // Se já está registrado, mostrar menu de opções
      setMenuAnchor(event.currentTarget);
      return;
    }

    setLoading(true);
    try {
      const success = await requestPermission();
      if (success) {
        alert('✅ Push notifications ativadas com sucesso! Você receberá notificações mesmo com o app fechado.');
      } else {
        alert('❌ Não foi possível ativar push notifications. Verifique as configurações do navegador.');
      }
    } catch (error) {
      console.error('Erro:', error);
      alert('❌ Erro ao ativar push notifications: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleTestNotification = async () => {
    setMenuAnchor(null);
    const success = await testNotification();
    if (!success) {
      alert('❌ Teste falhou! Verifique as permissões do navegador.');
    }
  };

  const handleTestSWNotification = async () => {
    setMenuAnchor(null);
    const success = await testServiceWorkerNotification();
    if (!success) {
      alert('❌ Teste via Service Worker falhou!');
    }
  };

  const handleForceTest = async () => {
    setMenuAnchor(null);
    const success = await forceShowNotification();
    if (!success) {
      console.log('Teste forçado falhou');
    }
  };

  const handleForceSWTest = async () => {
    setMenuAnchor(null);
    const success = await forceShowSWNotification();
    if (!success) {
      console.log('Teste forçado via SW falhou');
    }
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  if (permission === 'granted' && isRegistered) {
    return (
      <>
        <Tooltip title="Push notifications ativadas - Clique para testar">
          <IconButton 
            color="primary" 
            size="small"
            onClick={handleClick}
          >
            <Notifications />
          </IconButton>
        </Tooltip>
        <Menu
          anchorEl={menuAnchor}
          open={Boolean(menuAnchor)}
          onClose={handleCloseMenu}
        >
          <MenuItem onClick={handleTestNotification}>
            🧪 Testar Notificação Direta
          </MenuItem>
          <MenuItem onClick={handleTestSWNotification}>
            🔧 Testar via Service Worker
          </MenuItem>
          <MenuItem onClick={handleForceTest}>
            🔨 Forçar Teste Direto (Debug)
          </MenuItem>
          <MenuItem onClick={handleForceSWTest}>
            🔨 Forçar Teste SW (Debug)
          </MenuItem>
        </Menu>
      </>
    );
  }

  if (variant === 'icon') {
    return (
      <Tooltip title="Ativar notificações push">
        <IconButton 
          onClick={handleClick} 
          disabled={loading || !user?.id}
          color="default"
          size="small"
        >
          <NotificationsOff />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Button
      variant="outlined"
      color="primary"
      startIcon={isRegistered ? <Notifications /> : <NotificationsOff />}
      onClick={handleClick}
      disabled={loading || !user?.id}
      size="small"
    >
      {loading ? 'Ativando...' : isRegistered ? 'Notificações Ativas' : 'Ativar Notificações Push'}
    </Button>
  );
};

export default PushNotificationButton;

